export interface TextWithShortLinksProps {
  text: string;
  maxLengthLink?: number;
  addFormat?: boolean;
  stopPropagation?: boolean;
  className?: string;
  linkClassName?: string;
}

export const TextWithShortLinks = ({
  text,
  maxLengthLink = 40,
  addFormat = true,
  stopPropagation = false,
  className,
  linkClassName = 'text-blue-600 underline break-all',
}: TextWithShortLinksProps) => {
  const urlPartRegex = /((?:https?:\/\/|www\.)[^\s]+)/gi;
  const fullUrlRegex = /^(?:https?:\/\/|www\.)[^\s]+$/i;

  const shorten = (url: string) => {
    if (url.length <= maxLengthLink) return url;

    // Example: https://very-long-site.com/.../etc
    const part1 = url.slice(0, maxLengthLink / 2 - 3);
    const part2 = url.slice(-maxLengthLink / 2 + 3);

    return `${part1}...${part2}`;
  };

  const lines = text.split('\n');

  return (
    <span className={className}>
      {lines.map((line, lineIndex) => {
        const parts = line.split(urlPartRegex);

        return (
          <span key={lineIndex}>
            {parts.map((part, index) => {
              if (!fullUrlRegex.test(part)) {
                return <span key={index}>{part}</span>;
              }

              const href = part.toLowerCase().startsWith('www.') ? `https://${part}` : part;

              return (
                <a
                  key={index}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClassName}
                  title={part}
                  onClick={event => {
                    if (stopPropagation) {
                      event.stopPropagation();
                    }
                  }}
                >
                  {shorten(part)}
                </a>
              );
            })}

            {lineIndex < lines.length - 1 && addFormat === true && <br />}
          </span>
        );
      })}
    </span>
  );
};
